import React from 'react';
import { Reveal } from './Reveal';
const stats: [string, string][] = [['6', 'Complete Volumes'], ['360', 'Pages'], ['132', 'Court Drills'], ['100%', 'Ready to Teach']];
export function StatsBar() {
  return <section className="border-y border-tr-border bg-white px-5 py-10" aria-label="Tennis Ready by the numbers" data-id="element-173" data-mp="1oa3v1uarhltu">
      <Reveal className="mx-auto grid max-w-container grid-cols-2 gap-y-8 text-center md:grid-cols-4" data-id="element-174" data-mp="1jeesrj7cxqtu">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center px-4 ${index > 0 ? 'md:border-l md:border-tr-border' : ''}`} data-id="element-175" data-mp="19m8yu3xjozc0" data-mpi={index}>
            <span className="text-4xl font-bold leading-none tracking-tight text-tr-navy md:text-[2.75rem]" data-id="element-176" data-mp="10m2sd209kzmc">
              {value}
            </span>
            <span className="mt-2 text-[10px] font-semibold uppercase tracking-[0.16em] text-tr-grey/80 md:text-[11px]" data-id="element-177" data-mp="vm7xyoha5rwj">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}